<template>
  <div class="reports__panel--period">

    <b-field label="Fra dato">
      <b-datepicker v-model="internalDateFrom"
                    :focusedDate="internalDateFrom"
                    @input="dateFromUpdated"
                    locale="da-DK"
                    placeholder="Vælg en fra-dato">
      </b-datepicker>
    </b-field>

    <b-field label="Til dato">
      <b-datepicker v-model="internalDateTo"
                    :focusedDate="internalDateTo"
                    @input="dateToUpdated"
                    locale="da-DK"
                    placeholder="Vælg en til-dato">
      </b-datepicker>
    </b-field>

  </div>
</template>

<script>
export default {
  name: "reports-panel-period",
  props: {
    dateFrom: {
      type: Date,
      default: undefined
    },
    dateTo: {
      type: Date,
      default: undefined
    }
  },
  data: () => ({
    internalDateFrom: undefined,
    internalDateTo: undefined,
  }),
  created() {
    this.internalDateFrom = this.dateFrom;
    this.internalDateTo = this.dateTo;
  },
  computed: {

  },
  methods: {
    dateFromUpdated(newValue) {
      this.$emit("dateFrom", newValue);
    },
    dateToUpdated(newValue) {
      this.$emit("dateTo", newValue);
    }
  },
  watch: {
    "dateFrom"(newValue) {
      this.internalDateFrom = newValue;
    },
    "dateTo"(newValue) {
      this.internalDateTo = newValue;
    }
  }
}
</script>

<style lang="scss">
.reports__panel--period {
  display: flex;
  gap: 5px;

  .datepicker {
    input {
      background-color: #adadad;
      color: white;
      border-color: #bdbdbd;

      &:hover {
        border-color: #bdbdbd;
      }
    }
  }
}
</style>
